/**
 * Horizontal margin value common across components in the editor.
 * See figma: http://shortn/_zU422nei1K
 */ export var EditorMargin = {
    /** Margin value for desktop breakpoints. */ DESKTOP: "16px",
    /** Margin value for tablet breakpoints. */ TABLET: "20px",
    /** Margin value for mobile breakpoints. */ PHONE: "12px"
};
